import React from 'react';

const Title = ({actions, children}) => (
    <div className="title d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-3 mb-4">
        <h1>{children}</h1>
        {actions}
    </div>
);

export default Title;
